import * as React from 'react'
import { memo } from 'react'
const SvgWhatsapp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
  >
    <path
      d="M11.9 2.034A6.94 6.94 0 0 0 .984 10.406L0 14l3.678-.966a6.9 6.9 0 0 0 3.316.844H7a7 7 0 0 0 7-6.938 6.97 6.97 0 0 0-2.1-4.906M7 12.709a5.76 5.76 0 0 1-2.937-.8l-.209-.125-2.181.572.581-2.128-.138-.219a5.777 5.777 0 1 1 10.712-3.068A5.83 5.83 0 0 1 7 12.709m3.162-4.319c-.172-.088-1.025-.506-1.184-.563s-.275-.087-.391.088-.447.563-.55.681-.2.131-.375.044A4.72 4.72 0 0 1 5.3 6.578c-.178-.306.178-.284.509-.947a.32.32 0 0 0-.016-.3c-.044-.088-.391-.941-.534-1.287s-.284-.291-.391-.3-.216-.006-.331-.006a.64.64 0 0 0-.462.216A1.95 1.95 0 0 0 3.469 5.4a3.4 3.4 0 0 0 .706 1.794 7.75 7.75 0 0 0 2.962 2.619 3.4 3.4 0 0 0 2.081.434 1.78 1.78 0 0 0 1.169-.825 1.45 1.45 0 0 0 .1-.825c-.04-.078-.156-.122-.328-.206Z"
      data-name="wapp-icon"
    />
  </svg>
)
const Memo = memo(SvgWhatsapp)
export default Memo
